export default "/_next/static/images/walnut-12c4718d928a2493ed913d8aede0dc63.png";